"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropertyType;
(function (PropertyType) {
    PropertyType["FLAT"] = "flat";
    PropertyType["MID_TERRACE"] = "mid_terrace";
    PropertyType["SEMI_DETACHED"] = "semi_detached";
    PropertyType["DETACHED"] = "detached";
    PropertyType["END_TERRACE"] = "end_terrace";
    PropertyType["BUNGALOW"] = "bungalow";
    PropertyType["MAISONETTE"] = "maisonette";
    PropertyType["OTHER"] = "other";
})(PropertyType = exports.PropertyType || (exports.PropertyType = {}));
var PropertyAge;
(function (PropertyAge) {
    PropertyAge["NINETEENHUNDRED"] = "1900";
    PropertyAge["NINETEENTWENTYNINE"] = "1929";
    PropertyAge["NINETEENFORTYNINE"] = "1949";
    PropertyAge["NINETEENSIXTYSIX"] = "1966";
    PropertyAge["NINETEENSEVENTYFIVE"] = "1975";
    PropertyAge["NINTEENEIGHTYTWO"] = "1982";
    PropertyAge["NINETEENNINTY"] = "1990";
    PropertyAge["NINTEENNINTYFIVE"] = "1995";
    PropertyAge["TWOTHOUSANDTWO"] = "2002";
    PropertyAge["TWOTHOUSANDSIX"] = "2006";
    PropertyAge["TWOTHOUSANDSEVEN"] = "2007";
})(PropertyAge = exports.PropertyAge || (exports.PropertyAge = {}));
var Title;
(function (Title) {
    Title["MR"] = "mr";
    Title["MRS"] = "mrs";
    Title["MS"] = "ms";
    Title["MISS"] = "miss";
    Title["DR"] = "dr";
    Title["PROF"] = "prof";
})(Title = exports.Title || (exports.Title = {}));
var Gender;
(function (Gender) {
    Gender["MALE"] = "male";
    Gender["FEMALE"] = "female";
    Gender["TRANSGENDER"] = "transgender";
    Gender["OTHER"] = "other";
})(Gender = exports.Gender || (exports.Gender = {}));
var HousingTenure;
(function (HousingTenure) {
    HousingTenure["BUYING"] = "buying";
    HousingTenure["COUNCIL"] = "council";
    HousingTenure["HOMELESS"] = "homeless";
    HousingTenure["NO_FIXED"] = "no_fixed";
    HousingTenure["OWN"] = "own";
    HousingTenure["PART_OR_RENT"] = "part_or_rent";
    HousingTenure["PRIVATELY"] = "privately";
    HousingTenure["RENT_FREE"] = "rent_free";
    HousingTenure["SOCIAL"] = "social";
    HousingTenure["REFUSED"] = "refused";
    HousingTenure["OTHER"] = "other";
})(HousingTenure = exports.HousingTenure || (exports.HousingTenure = {}));
var SexualOrientation;
(function (SexualOrientation) {
    SexualOrientation["HETEROSEXUAL"] = "heterosexual";
    SexualOrientation["GAY"] = "gay";
    SexualOrientation["BISEXUAL"] = "bisexual";
    SexualOrientation["PANSEXUAL"] = "pansexual";
    SexualOrientation["ASKED_NOT_KNOWN"] = "asked_not_known";
    SexualOrientation["NOT_STATED"] = "not_stated";
})(SexualOrientation = exports.SexualOrientation || (exports.SexualOrientation = {}));
var BooleanOption;
(function (BooleanOption) {
    BooleanOption["YES"] = "yes";
    BooleanOption["NO"] = "no";
})(BooleanOption = exports.BooleanOption || (exports.BooleanOption = {}));
var BooleanOptional;
(function (BooleanOptional) {
    BooleanOptional["YES"] = "yes";
    BooleanOptional["NO"] = "no";
    BooleanOptional["PREFER_NOT"] = "prefer_not";
})(BooleanOptional = exports.BooleanOptional || (exports.BooleanOptional = {}));
var BooleanMaybe;
(function (BooleanMaybe) {
    BooleanMaybe["YES"] = "yes";
    BooleanMaybe["NO"] = "no";
    BooleanMaybe["MAYBE"] = "maybe";
})(BooleanMaybe = exports.BooleanMaybe || (exports.BooleanMaybe = {}));
var BooleanLoose;
(function (BooleanLoose) {
    BooleanLoose["YES"] = "yes";
    BooleanLoose["NO"] = "no";
    BooleanLoose["UNSURE"] = "unsure";
})(BooleanLoose = exports.BooleanLoose || (exports.BooleanLoose = {}));
var BooleanPartial;
(function (BooleanPartial) {
    BooleanPartial["YES"] = "yes";
    BooleanPartial["NO"] = "no";
    BooleanPartial["PARTIAL"] = "partial";
})(BooleanPartial = exports.BooleanPartial || (exports.BooleanPartial = {}));
var BooleanOther;
(function (BooleanOther) {
    BooleanOther["YES"] = "yes";
    BooleanOther["NO"] = "no";
    BooleanOther["OTHER"] = "other";
})(BooleanOther = exports.BooleanOther || (exports.BooleanOther = {}));
var BooleanOptionalUnsure;
(function (BooleanOptionalUnsure) {
    BooleanOptionalUnsure["YES"] = "yes";
    BooleanOptionalUnsure["NO"] = "no";
    BooleanOptionalUnsure["PREFER_NOT"] = "prefer_not";
    BooleanOptionalUnsure["DONT_KNOW"] = "dont_know";
})(BooleanOptionalUnsure = exports.BooleanOptionalUnsure || (exports.BooleanOptionalUnsure = {}));
var Language;
(function (Language) {
    Language["EN"] = "en";
    Language["AA"] = "aa";
    Language["AB"] = "ab";
    Language["AF"] = "af";
    Language["AM"] = "am";
    Language["AR"] = "ar";
    Language["AS"] = "as";
    Language["AY"] = "ay";
    Language["AZ"] = "az";
    Language["BA"] = "ba";
    Language["BE"] = "be";
    Language["BG"] = "bg";
    Language["BH"] = "bh";
    Language["BI"] = "bi";
    Language["BN"] = "bn";
    Language["BO"] = "bo";
    Language["BR"] = "br";
    Language["CA"] = "ca";
    Language["CO"] = "co";
    Language["CS"] = "cs";
    Language["CY"] = "cy";
    Language["DA"] = "da";
    Language["DE"] = "de";
    Language["DZ"] = "dz";
    Language["EL"] = "el";
    Language["EO"] = "eo";
    Language["ES"] = "es";
    Language["ET"] = "et";
    Language["EU"] = "eu";
    Language["FA"] = "fa";
    Language["FI"] = "fi";
    Language["FJ"] = "fj";
    Language["FO"] = "fo";
    Language["FR"] = "fr";
    Language["FY"] = "fy";
    Language["GA"] = "ga";
    Language["GD"] = "gd";
    Language["GL"] = "gl";
    Language["GN"] = "gn";
    Language["GU"] = "gu";
    Language["HA"] = "ha";
    Language["HI"] = "hi";
    Language["HR"] = "hr";
    Language["HU"] = "hu";
    Language["HY"] = "hy";
    Language["IA"] = "ia";
    Language["IE"] = "ie";
    Language["IK"] = "ik";
    Language["IN"] = "in";
    Language["IS"] = "is";
    Language["IT"] = "it";
    Language["IW"] = "iw";
    Language["JA"] = "ja";
    Language["JI"] = "ji";
    Language["JW"] = "jw";
    Language["KA"] = "ka";
    Language["KK"] = "kk";
    Language["KL"] = "kl";
    Language["KM"] = "km";
    Language["KN"] = "kn";
    Language["KO"] = "ko";
    Language["KS"] = "ks";
    Language["KU"] = "ku";
    Language["KY"] = "ky";
    Language["LA"] = "la";
    Language["LN"] = "ln";
    Language["LO"] = "lo";
    Language["LT"] = "lt";
    Language["LV"] = "lv";
    Language["MG"] = "mg";
    Language["MI"] = "mi";
    Language["MK"] = "mk";
    Language["ML"] = "ml";
    Language["MN"] = "mn";
    Language["MO"] = "mo";
    Language["MR"] = "mr";
    Language["MS"] = "ms";
    Language["MT"] = "mt";
    Language["MY"] = "my";
    Language["NA"] = "na";
    Language["NE"] = "ne";
    Language["NL"] = "nl";
    Language["NO"] = "no";
    Language["OC"] = "oc";
    Language["OM"] = "om";
    Language["PA"] = "pa";
    Language["PL"] = "pl";
    Language["PS"] = "ps";
    Language["PT"] = "pt";
    Language["QU"] = "qu";
    Language["RM"] = "rm";
    Language["RN"] = "rn";
    Language["RO"] = "ro";
    Language["RU"] = "ru";
    Language["RW"] = "rw";
    Language["SA"] = "sa";
    Language["SD"] = "sd";
    Language["SG"] = "sg";
    Language["SH"] = "sh";
    Language["SI"] = "si";
    Language["SK"] = "sk";
    Language["SL"] = "sl";
    Language["SM"] = "sm";
    Language["SN"] = "sn";
    Language["SO"] = "so";
    Language["SQ"] = "sq";
    Language["SR"] = "sr";
    Language["SS"] = "ss";
    Language["ST"] = "st";
    Language["SU"] = "su";
    Language["SV"] = "sv";
    Language["SW"] = "sw";
    Language["TA"] = "ta";
    Language["TE"] = "te";
    Language["TG"] = "tg";
    Language["TH"] = "th";
    Language["TI"] = "ti";
    Language["TK"] = "tk";
    Language["TL"] = "tl";
    Language["TN"] = "tn";
    Language["TO"] = "to";
    Language["TR"] = "tr";
    Language["TS"] = "ts";
    Language["TT"] = "tt";
    Language["TW"] = "tw";
    Language["UK"] = "uk";
    Language["UR"] = "ur";
    Language["UZ"] = "uz";
    Language["VI"] = "vi";
    Language["VO"] = "vo";
    Language["WO"] = "wo";
    Language["XH"] = "xh";
    Language["YO"] = "yo";
    Language["ZH"] = "zh";
    Language["ZU"] = "zu";
})(Language = exports.Language || (exports.Language = {}));
var DisabilityCategory;
(function (DisabilityCategory) {
    DisabilityCategory["PHYSICAL"] = "physical";
    DisabilityCategory["VISUAL"] = "visual";
    DisabilityCategory["HEARING"] = "hearing";
    DisabilityCategory["MENTAL"] = "mental";
    DisabilityCategory["LEARNING"] = "learning";
    DisabilityCategory["LONGTERM"] = "longterm";
})(DisabilityCategory = exports.DisabilityCategory || (exports.DisabilityCategory = {}));
var Religion;
(function (Religion) {
    Religion["BAHA"] = "baha";
    Religion["BUDDHIST"] = "buddhist";
    Religion["CHRISTIAN"] = "christian";
    Religion["HINDU"] = "hindu";
    Religion["JAIN"] = "jain";
    Religion["JEWISH"] = "jewish";
    Religion["MUSLIM"] = "muslim";
    Religion["PAGAN"] = "pagan";
    Religion["SIKH"] = "sikh";
    Religion["ZOROASTRIAN"] = "zoroastrian";
    Religion["OTHER"] = "other";
    Religion["NONE"] = "none";
    Religion["DECLINED"] = "declined";
    Religion["UNKNOWN"] = "unknown";
})(Religion = exports.Religion || (exports.Religion = {}));
var Ethnicity;
(function (Ethnicity) {
    Ethnicity["WHITE"] = "white";
    Ethnicity["BLACK_OR_BRITISH_BLACK"] = "black_british_black";
    Ethnicity["ASIAN_OR_BRITISH_ASIAN"] = "asian_british_asian";
    Ethnicity["CHINESE"] = "chinese";
    Ethnicity["MIXED"] = "mixed";
    Ethnicity["OTHER"] = "other";
    Ethnicity["DECLINED"] = "declined";
})(Ethnicity = exports.Ethnicity || (exports.Ethnicity = {}));
var SubEthnicity;
(function (SubEthnicity) {
    SubEthnicity["BRITISH"] = "british";
    SubEthnicity["IRISH"] = "irish";
    SubEthnicity["TURKISH"] = "turkish";
    SubEthnicity["CARIBBEAN"] = "caribbean";
    SubEthnicity["AFRICAN"] = "african";
    SubEthnicity["INDIAN"] = "indian";
    SubEthnicity["PAKISTANI"] = "pakistani";
    SubEthnicity["BANGLADESHI"] = "bangladeshi";
    SubEthnicity["WHITE_AND_BLACK_CARIBBEAN"] = "white_black_caribbean";
    SubEthnicity["WHITE_AND_BLACK_AFRICAN"] = "wihte_black_african";
    SubEthnicity["WHITE_AND_ASIAN"] = "white_asian";
    SubEthnicity["OTHER"] = "other";
    SubEthnicity["NONE"] = "none";
    SubEthnicity["REFUSED"] = "refused";
})(SubEthnicity = exports.SubEthnicity || (exports.SubEthnicity = {}));
//# sourceMappingURL=Options.enum.js.map